import React, { useState, useEffect } from 'react';
import { Download, Sparkles, ExternalLink } from 'lucide-react';
import yaml from 'js-yaml';

const DownloadButton = () => {
  const [latestVersion, setLatestVersion] = useState('1.0.0');
  const [downloadPath, setDownloadPath] = useState('学有所成-1.0.0-x64-Setup.exe');
  const [releaseDate, setReleaseDate] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [showTooltip, setShowTooltip] = useState(false);
  const baseUrl = 'https://qny.aiqji.com'; // 修改为 HTTPS

  useEffect(() => {
    // 获取最新版本信息
    const fetchLatestVersion = async () => {
      try {
        const response = await fetch(`${baseUrl}/latest.yml`, {
          cache: 'no-cache',
          headers: {
            'Cache-Control': 'no-cache'
          }
        });
        
        if (!response.ok) {
          throw new Error('Failed to fetch version');
        }
        
        const text = await response.text();
        const data = yaml.load(text);
        
        if (data) {
          // 读取版本号
          if (data.version) {
            setLatestVersion(data.version);
          }
          
          // 读取下载路径（优先使用 path，其次使用 files[0].url）
          if (data.path) {
            setDownloadPath(data.path);
          } else if (data.files && data.files[0] && data.files[0].url) {
            setDownloadPath(data.files[0].url);
          }
          
          // 读取发布日期
          if (data.releaseDate) {
            setReleaseDate(data.releaseDate);
          }
        }
      } catch (error) {
        console.error('获取最新版本失败:', error);
        // 使用默认值
      } finally {
        setIsLoading(false);
      }
    };

    fetchLatestVersion();
    
    // 每5分钟检查一次更新
    const interval = setInterval(fetchLatestVersion, 5 * 60 * 1000);
    
    return () => clearInterval(interval);
  }, []);

  const handleDownload = () => {
    const downloadUrl = `${baseUrl}/${downloadPath}`;
    // 使用 a 标签下载，添加 rel="noreferrer" 避免防盗链限制
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = downloadPath;
    link.rel = 'noreferrer noopener'; // 不发送 referer，绕过防盗链
    link.target = '_blank'; // 新窗口打开
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      {/* 固定在左下角的下载按钮 */}
      <div 
        className="fixed bottom-6 left-6 z-50"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <button
          onClick={handleDownload}
          disabled={isLoading}
          className="group relative bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white px-6 py-3 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105 flex items-center gap-3 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {/* 闪光效果 */}
          <div className="absolute -top-1 -right-1">
            <Sparkles className="w-5 h-5 text-yellow-300 animate-pulse" />
          </div>
          
          {/* 新标签 */}
          <span className="absolute -top-2 -left-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full animate-bounce">
            NEW
          </span>
          
          <Download className="w-5 h-5" />
          <span className="font-bold">下载桌面版</span>
          <ExternalLink className="w-4 h-4 opacity-70" />
        </button>

        {/* 悬停提示 */}
        {showTooltip && !isLoading && (
          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 bg-gray-900 text-white px-4 py-3 rounded-lg shadow-xl whitespace-nowrap">
            <div className="text-center">
              <p className="text-sm font-medium">{downloadPath.split('-')[0] || '学有所成'}桌面版</p>
              <p className="text-xs text-gray-300 mt-1">v{latestVersion} | Windows x64</p>
              {releaseDate && (
                <p className="text-xs text-gray-400 mt-1">
                  发布于 {new Date(releaseDate).toLocaleDateString('zh-CN')}
                </p>
              )}
              <p className="text-xs text-yellow-300 mt-1 flex items-center gap-1 justify-center">
                <Sparkles className="w-3 h-3" />
                全新推出，体验更佳
                <Sparkles className="w-3 h-3" />
              </p>
            </div>
            {/* 小三角箭头 */}
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-900"></div>
          </div>
        )}
      </div>
    </>
  );
};

export default DownloadButton;